import React from "react";
import { Box, Typography, Icon } from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import useAuthContext from "../modules/auth/hook/useAuthContext";

const BreadcrumbsDynamic = () => {
  const location = useLocation();
  const { navigation } = useAuthContext();

  const segmentos = location.pathname.split("/").filter(Boolean);

  const breadcrumbs: { nombre: string; path: string }[] = [];

  const obtenerNombre = (segmento: string, path: string) => {
    if (navigation) {
      for (const modulo of navigation) {
        if (modulo.pathRelativo === path) {
          return modulo.nombre;
        }

        const vista = modulo.vistas?.find((vista) => vista.pathRelativo === path);

        if (vista) {
          return vista.nombre;
        }
      }
    }

    return segmento.replace(/-/g, " ");
  };

  let pathAcumulado = "";

  segmentos.forEach((segmento) => {
    pathAcumulado += `/${segmento}`;

    // No mostrar "app"
    if (segmento === "app") {
      return;
    }

    breadcrumbs.push({
      nombre: obtenerNombre(segmento, pathAcumulado),
      path: pathAcumulado,
    });
  });

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#ffffff",
        borderRadius: "50px",
        padding: "6px 16px 6px 8px",
        boxShadow: "0px 2px 8px rgba(108, 115, 126, 0.05)",
        gap: 1,
      }}
    >
      {/* Home */}
      <Link to="/app/pacientes" style={{ textDecoration: "none", display: "flex" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#f4f6f9",
            color: "#333333",
            transition: "background-color 0.2s",
            "&:hover": {
              backgroundColor: "#e9ecef",
            },
          }}
        >
          <Icon sx={{ fontSize: "18px" }}>home</Icon>
        </Box>
      </Link>

      {breadcrumbs.map((item, index) => {
        const ultimo = index === breadcrumbs.length - 1;

        return (
          <React.Fragment key={item.path}>
            <Icon
              sx={{
                fontSize: "14px",
                color: "#8a92a6",
                display: "flex",
                alignItems: "center",
              }}
            >
              chevron_right
            </Icon>

            {ultimo ? (
              <Box
                sx={{
                  backgroundColor: "#f0f4fe",
                  borderRadius: "20px",
                  px: 2,
                  py: 0.5,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#5867dd",
                    textTransform: "capitalize",
                  }}
                >
                  {item.nombre}
                </Typography>
              </Box>
            ) : (
              <Link
                to={item.path}
                state={location.state}
                style={{
                  textDecoration: "none",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "capitalize",
                  }}
                >
                  {item.nombre}
                </Typography>
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default BreadcrumbsDynamic;